import React, {Component} from 'react'
import {Redirect, Route, Switch} from "react-router-dom"
import {connect} from 'react-redux'
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
import globalTranslations from "./translations/global.json";

import Header from './containers/header/header'
import Error from './containers/error/error'
import Login from './containers/login/login'
import Otp from './containers/otp/otp'
import User from './containers/user/user'
import UserCreate from './containers/user/userCreate'
import UserDetail from './containers/user/userDetail'
import UserEdit from './containers/user/userEdit'
import Bank from './containers/bank/bank'
import BankDetail from './containers/bank/bankDetail'
import BankEdit from './containers/bank/bankEdit'
import Corporate from './containers/corporate/corporate'
import CorporateCreate from './containers/corporate/corporateCreate'
import CorporateDetail from './containers/corporate/corporateDetail'
import CorporateEdit from './containers/corporate/corporateEdit'
import Campaign from './containers/campaign/campaign'
import CampaignCreate from './containers/campaign/campaignCreate'
import CampaignDetail from './containers/campaign/campaignDetail'
import CampaignEdit from './containers/campaign/campaignEdit'
import Password from './containers/password/password'
import Recover from './containers/password/recover'
import File from './containers/file/file'
import History from "./containers/file/history";
import Plick from './containers/file/plick'
import PlickDetail from './containers/file/plickDetail'
import Profile from './containers/profile/profile'
import ContoCorrenteCreate from "./containers/contoCorrente/contoCorrenteCreate";
import ContoCorrenteEdit from "./containers/contoCorrente/contoCorrenteEdit";
import Admin from './containers/layout/Admin'
import Auth from './containers/layout/Auth'
import Index from './views/Index.js'
import Report from './containers/report/report'
import * as actions from "./store/actions/actions";
import Progress from "./containers/progress/progress";
import NotFound from "./containers/notFound/notFound";
import Faq from "./containers/faq/faq";
import * as Roles from "./store/actions/roles";
import Reset from "./containers/reset/reset";

class App extends Component {
  constructor(props) {
    super(props);

    const languages = [
      { name: "Italian", code: "it" },
      { name: "English", code: "en" }
    ];

    let testLang="it";
    if(this.props.language !== ""){
        testLang= this.props.language;
    }

    this.props.initialize({
      languages,
      translation: globalTranslations,
      options: {
        renderToStaticMarkup,
        renderInnerHtml: true,
        defaultLanguage:testLang
      }
    });
  }
    render() {
        let layout = "";
        let routes = <Switch>
            <Route path="/notFound" component={NotFound}/>
            <Route path="/:bank" exact component={Login}/>
            <Route path="/error" component={Error}/>
            <Route path="/:bank/:email/change" exact component={Password}/>
            <Route path="/:bank/recover" component={Recover}/>
            <Redirect to="/notFound" exact/>
        </Switch>
        layout = <Auth>
            {routes}
        </Auth>
        if (this.props.token && !this.props.authenticated) {
            routes = <Switch>
                <Route path="/otp" component={Otp}/>
                <Route path="/error" component={Error}/>
                <Redirect to="/otp"/>

            </Switch>
            layout = <Auth>
                {routes}
            </Auth>
        } else if (this.props.token && this.props.authenticated) {
            let dateNow = new Date();
            let role=this.props.authenticatedUser.role;
            let userReseted=this.props.authenticatedUser.userReseted
            if (Date.parse(localStorage.getItem('expirationDate')) > dateNow.getTime()) {
                if(userReseted===true){
                    routes =
                        <Switch>
                            <Route path="/reset" exact component={Reset}></Route>
                            <Redirect to="/reset" exact/>
                        </Switch>
                }else{
                    if(role===Roles.BANK_SUPER_ADMIN || role===Roles.BANK_CORPORATE_ADMIN || role===Roles.BANK_CORPORATE_AUTHORIZER ||
                        role===Roles.BANK_ADMIN || role === Roles.PAYDO_ADMIN || role === Roles.PAYDO_MANAGER || role === Roles.PAYDO_USER
                        || role === Roles.CORPORATE_ADMIN || role === Roles.BANK_AUTHORIZER || role === Roles.BANK_OPERATOR){
                        routes =
                            <Switch>
                                <Route path="/user" exact component={User}/>
                                <Route path="/user/create" exact component={UserCreate}/>
                                <Route path="/user/:id" exact component={UserDetail}/>
                                <Route path="/user/edit/:id" exact component={UserEdit}/>
                                <Route path="/bank" exact component={Bank}/>
                                <Route path="/bank/:id" exact component={BankDetail}/>
                                <Route path="/bank/edit/:id" exact component={BankEdit}/>
                                <Route path="/corporate" exact component={Corporate}/>
                                <Route path="/corporate/create" exact component={CorporateCreate}/>
                                <Route path="/corporate/:id" exact component={CorporateDetail}/>
                                <Route path="/corporate/edit/:id" exact component={CorporateEdit}/>
                                <Route path="/corporate/edit/:id/contoCorrente/:id" exact component={ContoCorrenteEdit}/>
                                <Route path="/corporate/edit/:id/contoCorrente/" exact component={ContoCorrenteCreate}/>
                                <Route path="/campaign" exact component={Campaign}/>
                                <Route path="/campaign/create" exact component={CampaignCreate}/>
                                <Route path="/campaign/:id" exact component={CampaignDetail}/>
                                <Route path="/campaign/edit/:id" exact component={CampaignEdit}/>
                                <Route path="/file" exact component={File}/>
                                <Route path="/file/:id/plick" exact component={Plick}/>
                                <Route path="/file/:id/history" exact component={History}/>
                                <Route path="/file/:id/plick/:id" exact component={PlickDetail}/>
                                <Route path="/report" exact component={Report}/>
                                <Route path="/profile" exact component={Profile}/>
                                <Route path="/index" exact component={Index}/>
                                <Route path="/faq" exact component={Faq}/>
                                <Redirect to="/index" exact/>
                            </Switch>
                    }else if(role===Roles.CORPORATE_OPERATOR || role===Roles.CORPORATE_AUTHORIZER){
                        routes =
                            <Switch>
                                <Route path="/file" exact component={File}/>
                                <Route path="/file/:id/plick" exact component={Plick}/>
                                <Route path="/file/:id/history" exact component={History}/>
                                <Route path="/file/:id/plick/:id" exact component={PlickDetail}/>
                                <Route path="/report" exact component={Report}/>
                                <Route path="/profile" exact component={Profile}/>
                                <Route path="/index" exact component={Index}/>
                                <Route path="/faq" exact component={Faq}/>
                                <Redirect to="/index" exact/>
                            </Switch>
                    }
                }
            layout =
                <Admin>
                    <Header/>
                    {routes}
                    <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700" rel="stylesheet"/>
                </Admin>
            }else{
            this.props.cleanToken();
            }
        }
        return (
            <div>
                <Progress></Progress>
                {layout}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.authentication.authenticatedUser.token,
        authenticated: state.authentication.authenticatedUser.authenticated,
        authenticatedUser: state.authentication.authenticatedUser,
        language: state.authentication.authenticatedUser.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        cleanToken:() =>dispatch({type:actions.AUTHENTICATION_CLEAN_TOKEN})
    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(App));